import React from 'react';

const MAX_COUNT = 99;

import SidePopup from '../components/side-popup';

import MeApi from '../lib/users/me-api';
import UpcomingGrant from "./grants/upcoming-grant";
import {stringToFriendlyDatetime} from "../lib/helpers/datetime-helpers";
import notificationDescription from "../lib/helpers/notification-descriptions";

class NotificationsMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            panelOpen: false,
            items : []
        };

    }

    getNotifications() {
        MeApi.notifications({page: 1, per_page: 100}).then(data => {
            this.setState({ items : data.data}, () => {
                MeApi.notificationsMarkAllRead();
            });
        });
    }

    render() {
        let {notificationCount} = this.props;

        return (
            <>
                {
                    this.state.panelOpen &&
                    <SidePopup
                        title={'Notifications'}
                        onClose={() => this.setState({panelOpen: false})}
                    >
                        <div className="progress__content">
                            <div className="progress__inner">
                        {
                            this.state.items.map((item, index) => {
                                const text = notificationDescription(item)
                                return(
                                    <UpcomingGrant
                                        key={index}
                                        id={text.description}
                                        description={text.title}
                                        link={text.link}
                                        read={item?.read_by?.length > 0}
                                        meta={`${stringToFriendlyDatetime(item.created_at)}`}
                                    />
                                );
                            })
                        }
                            </div>
                        </div>
                    </SidePopup>

                }
                <div class="notifications-menu">
                    <div className="notifications-menu__icon"
                         onClick={() => this.setState({panelOpen: !this.state.panelOpen},  () => this.getNotifications())}>
                        <svg className={'notifications-menu__icon-image'} xmlns="http://www.w3.org/2000/svg" width="24"
                             height="24" viewBox="0 0 24 24">
                            <path id="Path_217" data-name="Path 217" d="M0,0H24V24H0Z" fill="none"/>
                            <path id="Path_218" data-name="Path 218"
                                  d="M20,17h2v2H2V17H4V10a8,8,0,0,1,16,0Zm-2,0V10A6,6,0,0,0,6,10v7ZM9,21h6v2H9Z"
                                  fill="#fcf7ff"/>
                        </svg>
                        {
                            notificationCount?.unread >= 1 &&
                            <div className="notifications-menu__count">
                                {notificationCount?.unread >= MAX_COUNT ? `${MAX_COUNT}+` : notificationCount?.unread}
                            </div>
                        }

                    </div>
                </div>
            </>
        );
    }

}

export default NotificationsMenu;
